import React from "react";
import { Link } from "react-router-dom";
import ICONS from "../../../constants/icons";
import {
  BackBtnWrapper,
  BelinsonHeader,
  CardsWrapper,
  TitleWrapper,
  VideosPageWrapper,
} from "../components";
import GameCard from "./GameCard";
import { gamesData } from "./gamesData";

const BelinsonGamePage = () => {
  return (
    <VideosPageWrapper>
      <BelinsonHeader>
        <Link to="/app/belinson">
          <BackBtnWrapper>
            <ICONS.SidebarCloser />
            <div>Back</div>
          </BackBtnWrapper>
        </Link>
        <TitleWrapper>Games</TitleWrapper>
      </BelinsonHeader>
      <CardsWrapper>
        {gamesData.map((game) => (
          <GameCard game={game} key={game.id} />
        ))}
      </CardsWrapper>
    </VideosPageWrapper>
  );
};

export default BelinsonGamePage;
